module.exports = __webpack_public_path__ + "img/icon-checkmark-lightgreen.47384816.svg";